const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const CONTENT_API_ORIGIN = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

const buildContentApiUrl = (path) => {
  if (!CONTENT_API_ORIGIN) {
    return path;
  }

  if (CONTENT_API_ORIGIN.endsWith('/api') && path.startsWith('/api/')) {
    return `${CONTENT_API_ORIGIN}${path.slice(4)}`;
  }

  return `${CONTENT_API_ORIGIN}${path}`;
};

export const fetchPodcastPage = async ({ limit = 12, cursor, signal } = {}) => {
  const searchParams = new URLSearchParams({ limit: String(limit) });

  if (cursor) {
    searchParams.set('cursor', cursor);
  }

  const response = await fetch(
    buildContentApiUrl(`/api/podcasts?${searchParams.toString()}`),
    { signal }
  );

  if (!response.ok) {
    throw new Error('Podcast notes could not be loaded.');
  }

  const data = await response.json();

  // Preserve compatibility with an older API response during local development.
  if (Array.isArray(data)) {
    return {
      podcasts: data.slice(0, limit),
      remainingPodcasts: data.slice(limit),
      hasMore: data.length > limit,
      nextCursor: null,
    };
  }

  if (!data || !Array.isArray(data.podcasts)) {
    throw new Error('Podcast notes could not be loaded.');
  }

  const hasMore = data.pagination?.hasMore === true;
  const nextCursor = typeof data.pagination?.nextCursor === 'string'
    ? data.pagination.nextCursor.trim()
    : '';

  if (hasMore && !nextCursor) {
    throw new Error('Podcast notes could not be loaded.');
  }

  return {
    podcasts: data.podcasts,
    remainingPodcasts: [],
    hasMore,
    nextCursor: nextCursor || null,
  };
};

export const fetchPodcastNotes = async (id, { signal } = {}) => {
  const response = await fetch(
    buildContentApiUrl(`/api/podcasts/${encodeURIComponent(id)}`),
    { signal }
  );

  if (!response.ok) {
    throw new Error('Podcast notes could not be loaded.');
  }

  const data = await response.json();

  if (!data?.metadata || !Array.isArray(data.content?.results)) {
    throw new Error('Podcast notes could not be loaded.');
  }

  return data;
};

export const fetchReads = async ({ signal } = {}) => {
  const response = await fetch(buildContentApiUrl('/api/reads'), { signal });

  if (!response.ok) {
    throw new Error('Reading list could not be loaded.');
  }

  const data = await response.json();

  if (!Array.isArray(data)) {
    throw new Error('Reading list could not be loaded.');
  }

  return data;
};

export const fetchGitHubRepos = async (username) => {
  try {
    const response = await fetch(`https://api.github.com/users/${username}/repos`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching GitHub repos:', error);
    return [];
  }
};

export const login = async (credentials) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });
    return await response.json();
  } catch (error) {
    console.error('Login error:', error);
    return null;
  }
};
